import { Box, Typography, List, ListItem,Grid,Button } from "@mui/material";
import { Link, TextField, Divider } from "@mui/material";
import { Phone, Email, LocationOn, Facebook, Twitter, Instagram, LinkedIn } from "@mui/icons-material";

function Footer() {
    return(
<Box sx={{ 
      backgroundColor: 'rgb(52, 52, 52)',
      color: '#fff',
      padding: '30px 0',
      marginTop: 'auto'
    }}>
      <Grid container spacing={4} sx={{ maxWidth: '1200px', margin: '0 auto', padding: '0 20px' }}>
        {/* Customer Service */}
        <Grid item xs={12} sm={6} md={3}>
          <Typography variant="h6" gutterBottom sx={{ fontWeight: 'bold', mb: 2 }}>
            Customer Service
          </Typography>
          <List dense>
            {['Contact Us', 'Shipping Policy', 'Returns & Exchanges', 'FAQ', 'Size Guide'].map((text) => (
              <ListItem key={text} disableGutters>
                <Link href="#" color="inherit" underline="hover" sx={{ fontSize: '0.875rem' }}>
                  {text}
                </Link>
              </ListItem>
            ))}
          </List>
        </Grid>

        {/* Quick Links */}
        <Grid item xs={12} sm={6} md={3}>
          <Typography variant="h6" gutterBottom sx={{ fontWeight: 'bold', mb: 2 }}>
            Quick Links
          </Typography>
          <List dense>
            {['New Arrivals', 'Best Sellers', 'Sale', 'Gift Cards', 'Store Locator'].map((text) => (
              <ListItem key={text} disableGutters>
                <Link href="#" color="inherit" underline="hover" sx={{ fontSize: '0.875rem' }}>
                  {text}
                </Link>
              </ListItem>
            ))}
          </List>
        </Grid>

        {/* Company Info */}
        <Grid item xs={12} sm={6} md={3}>
          <Typography variant="h6" gutterBottom sx={{ fontWeight: 'bold', mb: 2 }}>
            Our Company
          </Typography>
          <List dense>
            <ListItem disableGutters>
              <Phone sx={{ fontSize: '1rem', mr: 1 }} />
              <Typography variant="body2">+1 (800) 123-4567</Typography>
            </ListItem>
            <ListItem disableGutters>
              <Email sx={{ fontSize: '1rem', mr: 1 }} />
              <Typography variant="body2">support@example.com</Typography>
            </ListItem>
            <ListItem disableGutters>
              <LocationOn sx={{ fontSize: '1rem', mr: 1 }} />
              <Typography variant="body2">New York, USA</Typography>
            </ListItem>
          </List>
        </Grid>

        {/* Newsletter */}
        <Grid item xs={12} sm={6} md={3}>
          {/* <Typography variant="h6" gutterBottom sx={{ fontWeight: 'bold', mb: 2 }}>
            Newsletter
          </Typography> */}
          {/* <Typography variant="body2" sx={{ mb: 2 }}>
            Subscribe to get updates about our latest products and special offers!
          </Typography> */}
          {/* <TextField
            variant="outlined"
            placeholder="Enter your email"
            size="small"
            sx={{
              backgroundColor: '#fff',
              borderRadius: '4px',
              border:"none",
              mb: 2,
              '& .MuiOutlinedInput-root': {
                paddingRight: '0'
              }
            }}
            InputProps={{
              endAdornment: (
                <Button
                  variant="contained"
                  sx={{
                    backgroundColor: '#2FA8EF',
                    color: '#fff',
                    '&:hover': {
                      backgroundColor: 'rgb(225, 190, 210)'
                    }
                  }}
                >
                  Subscribe
                </Button>
              )
            }}
          /> */}
          {/* <Box sx={{ mt: 2 }}> */}
          <Typography variant="h6" gutterBottom sx={{ fontWeight: 'bold', mb: 2 }}>
           Follow Us:
          </Typography>
            <Box sx={{ display: 'flex', gap: 1 }}>
              {[Facebook, Twitter, Instagram, LinkedIn].map((Icon, index) => (
                <Button
                  key={index}
                  variant="outlined"
                  sx={{
                    minWidth: '32px',
                    height: '32px',
                    color: '#fff',
                    borderColor: '#fff',
                    '&:hover': {
                      borderColor: 'rgb(239, 215, 229)',
                      color: 'rgb(239, 215, 229)'
                    }
                  }}
                >
                  <Icon fontSize="small" />
                </Button>
              ))}
            {/* </Box> */}
          </Box>
        </Grid>
      </Grid>

      <Divider sx={{ borderColor: 'rgba(255,255,255,0.2)', my: 4, mx: 'auto', width: '90%' }} />

      <Typography variant="body2" align="center" sx={{ opacity: 0.8 }}>
        © {new Date().getFullYear()} Elite Infotech Pvt.Ltd. All rights reserved.
      </Typography>
    </Box>
    )

            }
            export default Footer